export default {
  title: 'Voulez-vous vraiment supprimer votre compte ?',
  description:
    "Cette action est définitive. Vous perdrez l'accès à vos commandes, points de fidélité et préférences enregistrées.",
  labels: {
    loading: 'Suppression de votre compte…',
  },
  buttons: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  toasts: {
    success:
      "Votre compte a été définitivement supprimé. Vous n'avez plus accès à votre historique de commandes, vos points de fidélité ni vos données enregistrées.",
    error:
      "Une erreur s'est produite. Veuillez réessayer. Si le problème persiste, contactez notre équipe d'assistance : {{supportEmail}}",
  },
};
